import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import CustomerAppointment from "./CustomerAppointment";

import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import { useDispatch, useSelector } from "react-redux";
import PatientDetails from "./PatientDetails";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import { useParams } from "react-router-dom";
import {
  useGetAppoinmentbyIdQuery,
  useGetPatientDetailsbyIdQuery,
} from "../../../Service/appoinment";

import Toast from "../../../Component/DigitalMarketing/Toast";

function UpdateAppoinment() {
  const { id } = useParams();
  const response: any = useGetPatientDetailsbyIdQuery(id);
  const response1: any = useGetAppoinmentbyIdQuery(id);
  // console.log(response);

  const { open, message, openSnackBar, type } = useSnackbar();
  const dispatch = useDispatch();
  const callBackforErrorMessage = (value = true) => {};

  useEffect(() => {
    const data: any = {
      first: "Appointments",
      second:
        window.location.pathname.split("/")[2] === "add"
          ? "New Appointment"
          : response?.data?.[0]?.customerName,
    };
    dispatch(Change(data));
  }, [response?.data?.[0]?.customerName]);
  return (
    <Row>
      <Toast open={open} type={type} message={message} />
      {window.location.pathname.split("/")[2] === "add" ? (
        ""
      ) : (
        <Col md={6}>
          <div className="cards-box">
            <PatientDetails patientdata={response?.data?.[0]} />
          </div>
        </Col>
      )}
      <Col md={6}>
        <div className="Appointment">
          <ul className="Appointment-ul md-bord">
            <CustomerAppointment
              openSnackBar={openSnackBar}
              details={response1.data}
              id={id}
              callBackforErrorMessage={callBackforErrorMessage}
            />
          </ul>
        </div>
      </Col>
    </Row>
  );
}

export default UpdateAppoinment;
